<template>
	<div
		:class="context.classes.element"
		:data-type="type"
	>
		<input
			:type="type"
			v-model="context.model"
			:value="context.value"
			v-bind="context.attributes"
			@blur="context.blurHandler"
		>
		<component
			:is="`label`"
			v-if="usesDecorator"
			:class="context.classes.decorator"
			:for="context.attributes.id"
		/>
	</div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: "BorderBox",
    mixins: [FormulateInputMixin],
    computed: {
        type() {
            return this.context.type === "borderbox" ? "checkbox" : "radio";
        },
        usesDecorator () {
            return this.$formulate.options.useInputDecorators
        }
    }
}
</script>

<style>
[data-type="borderbox"][data-classification="box"],
[data-type="borderradio"][data-classification="box"] {
	@apply border border-gray-500 p-2 rounded;
}

[data-type="borderbox"][data-classification="box"].formulate-input,
[data-type="borderradio"][data-classification="box"].formulate-input {
	max-width: 20em;
}

[data-type="borderbox"][data-classification="group"] .formulate-input-element--group,
[data-type="borderradio"][data-classification="group"] .formulate-input-element--group {
	/* max-width: 100% !important; */
}

[data-type="borderbox"][data-classification="group"] .formulate-input-element--group [data-type="borderbox"],
[data-type="borderradio"][data-classification="group"] .formulate-input-element--group [data-type="borderradio"] {
	@apply rounded-none;
	margin-bottom: -1px;
}
[data-type="borderbox"][data-classification="group"] .formulate-input-element--group [data-type="borderbox"]:first-of-type,
[data-type="borderradio"][data-classification="group"] .formulate-input-element--group [data-type="borderradio"]:first-of-type {
	@apply rounded-t;
}
[data-type="borderbox"][data-classification="group"] .formulate-input-element--group [data-type="borderbox"]:last-of-type,
[data-type="borderradio"][data-classification="group"] .formulate-input-element--group [data-type="borderradio"]:last-of-type {
	@apply rounded-b;
}
</style>
